export interface PadelLevel {
  level: number;
  title: string;
  icon: string;
  description: string;
  characteristics: string[];
  objective: string;
}

export const PADEL_LEVELS: PadelLevel[] = [
  {
    level: 1,
    title: "Débutant / Découverte du padel",
    icon: "🎯",
    description: "Tu découvres le padel et apprends les règles fondamentales. Tu débutes avec des échanges simples et des déplacements limités.",
    characteristics: [
      "Compréhension du comptage des points et des positions sur le terrain",
      "Service à la cuillère basique, souvent irrégulier",
      "Peu ou pas d'utilisation des vitres",
      "Échanges courts (2 à 4 frappes maximum)",
      "Difficulté à se replacer correctement"
    ],
    objective: "Maîtriser le service, le renvoi régulier et le placement de base"
  },
  {
    level: 2,
    title: "Initié / Consolidation des bases",
    icon: "📈",
    description: "Tu maîtrises les coups de base (service, coup droit, revers) et commences à utiliser les vitres. Tu comprends mieux la logique du padel.",
    characteristics: [
      "Utilisation simple des vitres latérales et du fond",
      "Premiers échanges de 5 à 10 frappes",
      "Début de compréhension tactique (placement, rotations)",
      "Capacité à jouer en double avec coordination basique"
    ],
    objective: "Jouer plus de 10 coups par échange et comprendre les principes d'équipe"
  },
  {
    level: 3,
    title: "Débutant confirmé / Jeu de fond de court",
    icon: "🎾",
    description: "Tu es à l'aise en fond de court, tu commences à monter au filet et à te repositionner après tes coups.",
    characteristics: [
      "Utilisation des vitres avant et latérales de manière contrôlée",
      "Premières volées et smashes réussis",
      "Service diagonal plus régulier",
      "Début de transitions fond ↔ filet",
      "Bonne compréhension du rôle du partenaire"
    ],
    objective: "Construire des points avec intention et s'habituer à la défense via les vitres"
  },
  {
    level: 4,
    title: "Intermédiaire / Jeu complet",
    icon: "⚡",
    description: "Tu développes un jeu varié et équilibré, capable d'alterner entre défense et attaque. Tu participes à des tournois loisirs.",
    characteristics: [
      "Transitions fond ↔ filet maîtrisées",
      "Volées et smashs bien contrôlés",
      "Jeu d'équipe coordonné et communication efficace",
      "Début de participation à des tournois P25 – P100",
      "Classement estimé : entre 15 000e et 40 000e FFT"
    ],
    objective: "Renforcer la tactique collective et la précision dans les coups d'attaque"
  },
  {
    level: 5,
    title: "Intermédiaire avancé / Joueur régulier",
    icon: "🔥",
    description: "Tu joues avec régularité, maîtrises les coups intermédiaires (bandeja, vibora) et cherches la performance en compétition.",
    characteristics: [
      "Bandeja et vibora maîtrisées",
      "Lecture du jeu plus rapide",
      "Bon jeu de jambes et gestion du tempo",
      "Participations régulières aux tournois P100 / P250",
      "Classement homme : top 10 000 français (jusqu'à 6 000e)",
      "Classement femme : top 1 500 française (jusqu'à 900e)"
    ],
    objective: "Améliorer la vitesse de jeu, la défense des vitres doubles et la prise d'initiative"
  },
  {
    level: 6,
    title: "Avancé / Compétiteur amateur",
    icon: "⭐",
    description: "Tu es un joueur confirmé, avec un jeu rapide, une vision stratégique et une excellente condition physique.",
    characteristics: [
      "Répertoire technique complet (smash lifté, chiquita, bandeja lente, défense 360)",
      "Adaptation constante à l'adversaire",
      "Très bonne lecture du jeu",
      "Résultats solides en P250 / P500",
      "Classement homme : top 6 000 français (jusqu'à 3 000e)",
      "Classement femme : top 900 française (jusqu'à 450e)"
    ],
    objective: "Gagner en constance et en variations tactiques selon les styles adverses"
  },
  {
    level: 7,
    title: "Expert / Compétiteur confirmé",
    icon: "💎",
    description: "Tu fais partie des meilleurs joueurs régionaux, avec un jeu très rapide, précis et intelligent.",
    characteristics: [
      "Maîtrise parfaite des effets et des placements",
      "Défense et contre-attaque via vitres doubles",
      "Lecture et adaptation instantanée du jeu adverse",
      "Présence régulière dans les phases finales P500 / P1000",
      "Classement homme : top 3 000 français (jusqu'à 1 000e)",
      "Classement femme : top 450 française (jusqu'à 150e)"
    ],
    objective: "Viser les podiums régionaux et la régularité en haut de tableau"
  },
  {
    level: 8,
    title: "Élite / Professionnel",
    icon: "🏆",
    description: "Tu évolues dans les circuits professionnels FFT ou FIP. Tu as une préparation physique et mentale complète et une vision tactique d'expert.",
    characteristics: [
      "Maîtrise absolue de tous les coups, effets et positions",
      "Gestion du mental en situation de haute pression",
      "Tournois P1000 / P1500 / P2000 / FIP",
      "Classement homme : top 1 000 français",
      "Classement femme : top 150 française",
      "Joueur(se) sponsorisé(e), entraînement quotidien structuré"
    ],
    objective: "Performance durable et progression sur le circuit national/international"
  }
];

export const PREFERRED_POSITIONS = [
  { value: "left", label: "Gauche" },
  { value: "right", label: "Droite" },
  { value: "both", label: "Les deux" }
] as const;

export const GENDER_OPTIONS = [
  { value: "male", label: "Homme" },
  { value: "female", label: "Femme" }
] as const;
